import React from "react";
import { Star } from "lucide-react";

const REVIEWERS = [
  "/assets/ugc_woman_1.png",
  "/assets/ugc_woman_2.png",
  "/assets/insomniacs.png",
  "/assets/side_sleepers.png",
];

export default function ReviewsRatingStrip({ rating = 4.9, count = 2847 }) {
  return (
    <div
      data-testid="reviews-rating-strip"
      className="rounded-2xl border border-black/10 bg-[#fafaf8] p-3.5 flex items-center gap-3"
    >
      <div className="flex -space-x-2">
        {REVIEWERS.map((src) => (
          <img
            key={src}
            src={src}
            alt=""
            className="w-7 h-7 rounded-full border-2 border-white object-cover"
          />
        ))}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <div className="flex">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star
                key={i}
                size={12}
                className="fill-[#d8f06b] text-[#d8f06b]"
              />
            ))}
          </div>
          <span className="text-[12px] font-extrabold text-[#0e0e10] tabular-nums">
            {rating}
          </span>
          <span className="text-[10px] uppercase tracking-wider text-[#6b6b72] font-bold">
            Verified
          </span>
        </div>
        <div className="text-[11px] text-[#6b6b72] mt-0.5">
          Loved by <strong className="text-[#0e0e10]">{count.toLocaleString()}</strong> sleepers worldwide
        </div>
      </div>
    </div>
  );
}
